import React from 'react';
import { MaintenanceEntitySection } from './MaintenanceEntitySection';

const TransportMaintenance = () => (
  <div className="space-y-6 max-w-6xl">
    <div>
      <h2 className="text-xl font-semibold text-gray-900">Transport maintenance</h2>
     
    </div>
    <MaintenanceEntitySection
      apiType="Transport"
      addTitle="Add transport"
      valueLabel="Transport name (value)"
      valuePlaceholder="e.g. National Logistics"
      codePlaceholder="Optional — defaults to name"
      listHeading="Transport providers"
      emptyHint="No transport entries yet. Use the form on the left."
      deleteModalLabel="transport entry"
    />
  </div>
);

export default TransportMaintenance;
